  /* eslint max-len: ["error", 200] */
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Link } from 'react-router'
import { api } from '../../services/api'
import { publishTracking } from '../../services/tracking'
import '../sign-up/sign-up.css'
import chevron from '../../../media/back-chevron.svg'
import LoadingSvg from '../loading-svg'

export default class ForgotPassword extends Component {
  constructor(props) {
    super(props)

    this.state = {
      email: '',
      resetSent: false,
      uiPending: false,
    }
  }

  emailHandler = (e) => {
    this.setState({
      email: e.target.value,
    })
  }

  sendEmail = (e) => {
    e.preventDefault()

    if (!this.state.resetSent) {
      this.setState({ uiPending: true })
      const queryParams = new URLSearchParams(this.props.location.search)
      api.resetPassword(this.state.email, queryParams.get('site') || '')
      .then(() => {
        publishTracking({
          userAction: 'forgot pass submit',
          event: 'event149',
        })
      })

      setTimeout(() => {
        this.setState({ resetSent: true })
      }, 3000)
    }
  }

  render() {
    const { t } = this.props
    const { resetSent, uiPending } = this.state

    return (
      <div className="sign-up-page xs-flex xs-justify-center xs-items-center xs-fill-gray-lighter clearfix">
        <div className="auth-modal modal-content rounded xs-flex xs-justify-center xs-relative xs-flex-column xs-py3 xs-px4">

          <form className="forgot-email-dialog" onSubmit={this.sendEmail}>
            <div className="xs-text-center xs-text-3 xs-pb5 xs-relative">
              <Link to="/signin">
                <img alt="back-chevron" src={chevron} className="back-chevron cursor-pointer xs-absolute xs-t2 xs-l0" />
              </Link>
              <div className="modal-header__title xs-text-3 xs-px5">{t('FORGOT_HEADER')}</div>
            </div>

            <p className="xs-text-7 xs-text-gray xs-px4 xs-mb4 xs-text-center">
              {t('FORGOT_SUBTITLE')}
            </p>

            <input
              type="email"
              onChange={this.emailHandler}
              className={'sign-with email email-reset xs-mb0 text-input xs-mb4'}
              placeholder={t('YOUR_EMAIL')}
              autoComplete="email"
              required
            />

            {resetSent
              ? <span className="xs-text-center xs-px4 xs-block">{t('RECEIVE_EMAIL')}</span>
              : <button type="submit" className={`xs-fill-blue-cta rounded xs-border-none cond caps xs-text-white xs-py3 xs-col-12 ${uiPending && 'disabled'}`}>
                {uiPending
                  ? <LoadingSvg />
                  : t('SEND_LINK')
                }
              </button>
            }
          </form>

        </div>
      </div>
    )
  }
}

ForgotPassword.propTypes = {
  t: PropTypes.func.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/forgot-password/forgot-password.js